import React from "react";
import { View, Text } from "react-native";
import { FormattedMessage } from "react-intl";

import HeaderDefault from "../../components/HeaderDefault";
import Button from "../../components/Button";

import styles from "./styles";

const ConfirmSell = () => {
  return (
    <>
      <HeaderDefault title={<FormattedMessage id="confirmSell.confirmar" />} />

      <View style={styles.container}>
        <View style={styles.contentPrices}>
          <Text style={styles.infoPrice}>
            <FormattedMessage id="confirmSell.moeda" />
          </Text>
          <Text>
            <FormattedMessage id="confirmSell.gpxToken" />
          </Text>
        </View>
        <View style={styles.contentPrices}>
          <Text style={styles.infoPrice}>
            <FormattedMessage id="confirmSell.valorDoDia" />
          </Text>
          <Text>
            <FormattedMessage id="confirmSell.XX,XXXGpx" />
          </Text>
        </View>
        <View style={styles.contentPrices}>
          <Text style={styles.infoPrice}>
            <FormattedMessage id="confirmSell.valorVenda" />
          </Text>
          <Text>
            <FormattedMessage id="confirmSell.XX,XXXBrl" />
          </Text>
        </View>
      </View>

      <Button
        route={"ConfirmPassword"}
        text={<FormattedMessage id="confirmSell.confirma" />}
      />
    </>
  );
};

export default ConfirmSell;
